import { formatDate } from "../../../components/utility/utility";

// import placeImage from './../../../../src/assets/images/surgical.png'
let BlogAPIUrl = process.env.REACT_APP_BLOG_API_URL;


const MainBlog = ({ blogs }) => {
  return (
    <div className="MainBlog">
      <div className="top">
        <div className="topfirst">
          <img src={blogs.image ? `${BlogAPIUrl}uploads/files/${blogs.image}` : "placeImage"} alt="Image" />
        </div>
        <div className="topsecond">
          <h4>{blogs?.author?.name}</h4>
          <h5>| {formatDate(blogs?.created_at)}</h5>
        </div>
      </div>
      <div className="bottom">
        <div className="text-container">
          <div className="text">
            <h2 dangerouslySetInnerHTML={{ __html: blogs?.heading }}>
            </h2>
            <p dangerouslySetInnerHTML={{ __html: blogs?.description }}>
            </p>
          </div>
         
        </div>
      </div>
    </div>
  );
};

export default MainBlog;